<template>
  <div class="footer-dark">
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-3 item">
            <h3>Learn</h3>
            <ul>
              <li><a href="/user-guide">User Guide</a></li>
              <li><a href="/tutorials">Tutorials</a></li>
              <li><a href="/templates">Templates</a></li>
              <li></li>
            </ul>
          </div>
          <div class="col-sm-6 col-md-3 item">
            <h3>Contact</h3>
            <ul>
              <li><a href="/contact-us" target="blank">Contact Us</a></li>
            </ul>
          </div>
          <div class="col-md-6 item text">
            <h3>Bot Creator</h3>
            <ul>
              <li><a href="/about-us" target="blank">About Us</a></li>
              <li><a href="/pricing" target="blank">Pricing</a></li>
              <li><a href="/privacy-policy" target="blank">Privacy Policy</a></li>
              <li><a href="/terms-and-conditions" target="blank">Terms & Conditions</a></li>
              <li><a href="/refund-policy" target="blank">Refund Policy</a></li>
            </ul>
          </div>
        </div>
        <p class="copyright">Bot Creator © 2020</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
    name: 'Footer',
    data: function() {
        return {
        }
    },
    methods: {
    }
}
</script>